/**
 * Dictionnaires de libellés internes à `@exiplan/gantt` — chantier i18n studio Exidis.
 *
 * Le paquet ne dépend PAS de `react-i18next` : il est réutilisable hors de `client/`
 * (documentation, futur produit). L'appelant lui passe sa locale courante via la prop
 * `locale` (`'en'` par défaut) ; un appelant qui a ses propres besoins de libellés peut
 * fournir `labels` pour surcharger tout ou partie du dictionnaire résolu.
 */

export const GANTT_LOCALES = {
  en: {
    ganttLabel: 'Gantt chart',
    tasksHeader: 'Tasks',
    resizeSidebarLabel: 'Resize the task column',
    zoomGroupLabel: 'Zoom level',
    zoom: { day: 'Day', week: 'Week', month: 'Month', quarter: 'Quarter' },
    empty: 'No tasks to display.',
    expand: (title) => `Expand ${title}`,
    collapse: (title) => `Collapse ${title}`,
    barLabel: ({ title, kind, status, progress }) =>
      `${title}, ${kind}, ${status}, ${progress} percent complete`,
    quarterPrefix: 'Q',
  },
  fr: {
    ganttLabel: 'Diagramme de Gantt',
    tasksHeader: 'Tâches',
    resizeSidebarLabel: 'Redimensionner la colonne des tâches',
    zoomGroupLabel: 'Niveau de zoom',
    zoom: { day: 'Jour', week: 'Semaine', month: 'Mois', quarter: 'Trimestre' },
    empty: 'Aucune tâche à afficher.',
    expand: (title) => `Déplier ${title}`,
    collapse: (title) => `Replier ${title}`,
    barLabel: ({ title, kind, status, progress }) =>
      `${title}, ${kind}, ${status}, avancement ${progress} pourcent`,
    quarterPrefix: 'T',
  },
};

/** Résout un dictionnaire de libellés pour la locale donnée, repli sur `en`. */
export function resolveGanttLocale(locale, overrides) {
  const base = GANTT_LOCALES[locale] ?? GANTT_LOCALES.en;
  return overrides ? { ...base, ...overrides } : base;
}
